import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAppContext from '../hooks/useAppContext';
import { PROFILE_REQUIRED_FIELDS_FOR_STUDIO_REGISTRATION } from '../consts/mandatoryFields';

type ProfileValidationGuardProps = {
  children: React.ReactNode;
};

const ProfileValidationGuard: React.FC<ProfileValidationGuardProps> = ({
  children,
}) => {
  const { user, showAlert, isAdmin } = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();

  const hasValidProfile =
    user &&
    PROFILE_REQUIRED_FIELDS_FOR_STUDIO_REGISTRATION.every((field) => {
      const value = user[field];
      return value && (typeof value === 'string' ? value.trim() !== '' : true);
    });

  const isOnEditProfile = location.pathname === '/edit-profile';

  useEffect(() => {
    if (!hasValidProfile && !isOnEditProfile && !isAdmin) {
      navigate('/edit-profile', { replace: true });
    }
  }, [hasValidProfile, isOnEditProfile, navigate, showAlert]);

  return <>{children}</>;
};

export default ProfileValidationGuard;
